import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTable, MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { IconDetailComponent, IconDetailModel } from '../../../common/icon-detail/icon-detail.component';
import { StatusIndicatorComponent } from '../../../common/status-indicator/status-indicator.component';
import { Icons } from '../../../domain/enums/icons-enums';
import { InternalUserInfo } from '../../../domain/models/internal-userInfo-model';
import { UserGroup } from '../../../domain/models/user-group.model';
import { UserListDataSource } from '../../users/users-list/users-list.datasource';
import { UsersServicesService } from '../../../domain/services/users/users-services.service';
import { UserGroupServiceService } from '../../../domain/services/user-group/user-group.service.service';
import { DialogTypeEnum } from '../../../domain/enums/dialog-type.enum';
import { CustomDialogFactory } from '../../../domain/services/dialog/custom-dialog.factory';
import { MatCheckboxModule } from '@angular/material/checkbox';

@Component({
  selector: 'app-usergroup-users',
  standalone: true,
  imports: [  
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatButtonToggleModule,
        FormsModule,
        MatPaginatorModule,
        RouterModule,
        MatTableModule,
        MatInputModule,
        MatSortModule,
        MatSelectModule,
        CommonModule,
        MatDatepickerModule,
        MatNativeDateModule,
        StatusIndicatorComponent,
        IconDetailComponent,
        MatTableModule,
        MatCheckboxModule
              ],
  templateUrl: './usergroup-users.component.html',
  styleUrl: './usergroup-users.component.css'
})
export class UsergroupUsersComponent implements OnInit, AfterViewInit{
    @Input() currentUserGroup!: UserGroup;
      currentId: number = 0;
  constructor( private readonly dialog: CustomDialogFactory,private readonly route: ActivatedRoute,  private readonly service: UserGroupServiceService) {
      }

    ngAfterViewInit(): void { 
           const id: number = Number(this.route.snapshot.params['id']);
    if (id) {
      
    this.currentId = id;
    this.service.getUsersByGroup(id).subscribe(value => {
      this.users = value;   
        this.userModel = { icon: Icons.PersonPinIcon, label: 'Total Groups', value: value.length.toString() , hideVerticalLine: true};
     
      this.rebuildDataSource(value);
    });
    }
    
    
  }
  ngOnInit(): void {
  
    
  }

     @ViewChild(MatPaginator) paginator!: MatPaginator;
      @ViewChild(MatSort) sort!: MatSort;
      @ViewChild(MatTable) table!: MatTable<InternalUserInfo>;
 displayedColumns = [ 'firstName', 'lastName', 'emailAddress', 'phoneNumber','status','actions'];
  userModel: IconDetailModel | undefined;
    query = ""; 
    icons = Icons  
    users: InternalUserInfo[] = []; 
     usersToBeRemove: InternalUserInfo[] = []; 
  dataSource = new UserListDataSource([]); 
     
     

     rebuildDataSource(data: InternalUserInfo[]) {
          this.dataSource = new UserListDataSource(data); 
          this.dataSource.sort = this.sort;
          this.dataSource.paginator = this.paginator;
          this.table.dataSource = this.dataSource;
        }
onSearch() {
  this.paginator.pageIndex = 0; //reset paginator on search
  if (this.query.length > 2) {
    const data = this.users.filter(value =>
     value.firstName.toLowerCase().includes(this.query.toLowerCase())
      || value.lastName.toLowerCase().includes(this.query.toLowerCase())
      || value.phoneNumber.toLowerCase().includes(this.query.toLowerCase())
      ||value.userName.toLowerCase().includes(this.query.toLowerCase()));

    this.rebuildDataSource(data);
  }  
}
 
  mapstatus(status:number){
    if (status == 1){
      return "Active";
    }else{
      return "Inactive";
    }
  }
addMember(){
     this.dialog.openDialog(DialogTypeEnum.INCLUDE_USER_INTO_USER_GROUP, this.users, (data:  InternalUserInfo[]) => {
     this.users.push(...data);
     this.rebuildDataSource( this.users);
           });
}
removeUser(user: InternalUserInfo){
  this.usersToBeRemove.push(user)
  this.users = this.users.filter(item => item.id !== user.id);
  this.rebuildDataSource( this.users);
}
  toggleRow(row: any) { 
  }

  public save(){
    this.service.addMembers(this.currentId, this.users).subscribe(value => {
      
    });

     this.service.removeMembers(this.usersToBeRemove).subscribe(value => {
      
    });
  }
}
 


